import React, { useMemo } from 'react';
import { Col, Row } from 'react-bootstrap-5';
import { faBolt } from '@fortawesome/pro-solid-svg-icons';

import { Button } from 'components/ui/button';
import type { CallListItem } from 'bundles/connect/types';
import { callListUrl, CALL_CONSOLE } from 'bundles/connect/helpers/prospect_api';

type CallListCallCardProps = {
  callListId: number;
  callListItems: CallListItem[];
  callProgress: any;
}

export default function CallListCallCard({
  callListId,
  callListItems,
  callProgress,
}: CallListCallCardProps) {
  if (callListItems.length <= 0) return null;

  const currentCallListItem = useMemo(() => callListItems.find(item => item.viewedAt === null) || callListItems[0], []);

  return (
    <Row className="align-items-end justify-content-end">
      <Col xs="auto">
        {currentCallListItem ? (
          <>
            <small className="text-muted">Next To Outreach:</small>
            <h6 className="my-0">{currentCallListItem.callListable.name}</h6>
          </>
        ) : (
          <h5 className="my-0">Resume Calling</h5>
        )}
      </Col>
      <Col xs="auto">
        <Button
          href={callListUrl(CALL_CONSOLE, callListId)}
          icon={faBolt}
          label={callProgress.contacted > 0 ? 'Resume Outreach' : 'Start Outreach'}
        />
      </Col>
    </Row>
  );
}
